import { collection, getDocs } from 'firebase/firestore/lite';

async function getLogs(db){
    const logCollection = collection(db,'logs')
    const logSnapshot = await getDocs(logCollection);
    const logList = logSnapshot.docs;
    return logList;
}

export default getLogs